module.exports = __webpack_public_path__ + "static/media/video.c0d20504.jpg";